<template>
  <div class="wrapper">
	<Header></Header>
	<router-view></router-view>
	<Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
// import EventsListing from './components/EventsListing.vue'

export default {
	components: {
		Header,
		// EventsListing,
		Footer
	},
	data() {
		return {

		}
	},
	computed: {

	},
	methods: {

	},
	mounted() {

	}
}
</script>

<style lang="scss">

@font-face {
    font-family: 'Merlo Regular Italic';
    src: url('/fonts/Merlo-RoundRegularItalic.eot');
    src: url('/fonts/Merlo-RoundRegularItalic.eot');
    src: url('/fonts/Merlo-RoundRegularItalic.eot?#iefix') format('embedded-opentype');
    src: url('/fonts/Merlo-RoundRegularItalic.eot?#iefix') format('embedded-opentype'),
        url('/fonts/Merlo-RoundRegularItalic.woff2') format('woff2'),
        url('/fonts/Merlo-RoundRegularItalic.woff2') format('woff2'),
        url('/fonts/Merlo-RoundRegularItalic.woff') format('woff'),
        url('/fonts/Merlo-RoundRegularItalic.woff') format('woff'),
        url('/fonts/Merlo-RoundRegularItalic.ttf') format('truetype'),
        url('/fonts/Merlo-RoundRegularItalic.ttf') format('truetype'),
        url('/fonts/Merlo-RoundRegularItalic.svg#Merlo-RoundRegularItalic') format('svg'),
        url('/fonts/Merlo-RoundRegularItalic.svg#Merlo-RoundRegularItalic') format('svg');
    font-weight: normal;
    font-style: italic;
}

@font-face {
    font-family: 'Merlo Bold';
    src: url('/fonts/Merlo-RoundBold.eot');
    src: url('/fonts/Merlo-RoundBold.eot?#iefix') format('embedded-opentype'),
        url('/fonts/Merlo-RoundBold.woff2') format('woff2'),
        url('/fonts/Merlo-RoundBold.woff') format('woff'),
        url('/fonts/Merlo-RoundBold.ttf') format('truetype'),
        url('/fonts/Merlo-RoundBold.svg#Merlo-RoundBold') format('svg');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'Merlo Regular';
    src: url('/fonts/Merlo-RoundRegular.eot');
    src: url('/fonts/Merlo-RoundRegular.eot?#iefix') format('embedded-opentype'),
        url('/fonts/Merlo-RoundRegular.woff2') format('woff2'),
        url('/fonts/Merlo-RoundRegular.woff') format('woff'),
        url('/fonts/Merlo-RoundRegular.ttf') format('truetype'),
        url('/fonts/Merlo-RoundRegular.svg#Merlo-RoundRegular') format('svg');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Merlo Italic';
    src: url('/fonts/Merlo-RoundBoldItalic.eot');
    src: url('/fonts/Merlo-RoundBoldItalic.eot?#iefix') format('embedded-opentype'),
        url('/fonts/Merlo-RoundBoldItalic.woff2') format('woff2'),
        url('/fonts/Merlo-RoundBoldItalic.woff') format('woff'),
        url('/fonts/Merlo-RoundBoldItalic.ttf') format('truetype'),
        url('/fonts/Merlo-RoundBoldItalic.svg#Merlo-RoundBoldItalic') format('svg');
    font-weight: bold;
    font-style: italic;
}



body, html, iframe {
	padding: 0;
	margin: 0;
	border: 0;
}

.wrapper {
	font-family: 'Merlo Regular', sans-serif;
	font-weight: 100;
}
button, a {
	cursor: pointer;
}
</style>
